import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["maxHeight", "width", "children", "borderRadius", "containerRef", "useIEFixStyles", "withoutScrollBar", "classes", "options"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useMemo } from 'react';
import "../utils/fork/react-perfect-scrollbar/styles.side.css";
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import useRefSetter from "../hooks/useRefSetter";
import { isIE11 } from "../utils/detectDevice";
import PerfectScrollbar from "../utils/fork/react-perfect-scrollbar";
import styles from './Scrollbar.css';
import './ScrollbarCustom.side.css';
var cx = classNames.bind(styles); // Взято с https://perfectscrollbar.com/#section-options

var defaultOptions = {
  wheelPropagation: true,
  minScrollbarLength: 25
};
var Scrollbar = /*#__PURE__*/forwardRef(function Scrollbar(_ref, ref) {
  var maxHeight = _ref.maxHeight,
      width = _ref.width,
      children = _ref.children,
      borderRadius = _ref.borderRadius,
      containerRef = _ref.containerRef,
      _ref$useIEFixStyles = _ref.useIEFixStyles,
      useIEFixStyles = _ref$useIEFixStyles === void 0 ? true : _ref$useIEFixStyles,
      withoutScrollBar = _ref.withoutScrollBar,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, _excluded);

  var scrollStyle = {
    minScrollbarLength: 25
  };

  if (width) {
    scrollStyle.width = width;
  }

  if (maxHeight) {
    scrollStyle.maxHeight = maxHeight;
  }

  if (borderRadius) {
    scrollStyle.borderRadius = borderRadius;
  }

  var refSetter = useRefSetter(ref);
  var PSOptions = useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultOptions), options);
  }, [options]);
  return isIE11 ? /*#__PURE__*/React.createElement("div", {
    style: useIEFixStyles ? {
      maxHeight: "".concat(maxHeight, "px"),
      overflowY: 'auto'
    } : {},
    ref: refSetter,
    className: classes.root
  }, children) :
  /*#__PURE__*/
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  React.createElement(PerfectScrollbar, _extends({
    className: cx('scroll', classes.root),
    style: scrollStyle,
    containerRef: refSetter
  }, rest, {
    options: PSOptions
  }), children);
});
export default Scrollbar;